export const ROUTES = {
  BASE: "/",
  ABOUT: "/about",
  CONTACT: "/contact",
  GAMES: '/games',
  TERMS:'/terms',
  PRIVACY:'/privacy',
  RESPONSIBLE:'/responsible'
};